import { Controller } from "@hotwired/stimulus"
import { createPhotoSwipeLightbox } from '../lib/photoswipe-lightbox.js'

// Connects to data-controller="email-body-images"
// Wraps every <img> inside the email HTML body into a PhotoSwipe gallery link
// so body-embedded (CID-replaced) images are zoomable on click.
export default class extends Controller {
  connect() {
    this._buildGallery()
  }

  _buildGallery() {
    const imgs = this.element.querySelectorAll('img[src]')
    if (!imgs.length) return

    imgs.forEach((img) => {
      // Skip images already wrapped in an anchor
      if (img.parentNode.tagName === 'A') return

      const a = document.createElement('a')
      a.href = img.src
      a.dataset.photoswipe = 'email-body-images'
      a.dataset.type = 'image'
      a.dataset.pswpWidth  = img.naturalWidth  || img.width  || 800
      a.dataset.pswpHeight = img.naturalHeight || img.height || 600
      a.style.cursor = 'pointer'
      img.parentNode.insertBefore(a, img)
      a.appendChild(img)
    })

    this.lightbox = createPhotoSwipeLightbox(this.element)
  }

  disconnect() {
    if (this.lightbox) {
      this.lightbox.destroy()
      this.lightbox = null
    }
  }
}
